module.exports = __webpack_public_path__ + "afghanistan.svg?d196903c2d8a2f7b7ce311d8ef5ec382";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/afghanistan.svg
// module id = 85
// module chunks = 10